import { Component, OnInit } from '@angular/core';
import {faChevronRight} from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-reports-toolbar',
    templateUrl: './reports-toolbar.component.html',
    styleUrls: ['./reports-toolbar.component.scss'],
    standalone: false // NOSONAR
})
export class ReportsToolbarComponent implements OnInit {

  menuVariable:boolean=false;
  faChevronRight=faChevronRight;
  openMenu(){
    this.menuVariable=!this.menuVariable;
  }

  constructor() { }

  ngOnInit(): void {
    console.info('something')
  }

}
